import {classNames} from "shared/lib/classNames/classNames";
import {Header} from "widgets/Header";
import {MainPage} from "pages/MainPage";
import {AboutPage} from "pages/AboutPage";
import {Footer} from "widgets/Footer";
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import {PrivacyPage} from "pages/PrivacyPage";
import {TermsPage} from "pages/TermsPage";
import ScrollToAnchor from "shared/ui/ScrollToAnchor/ScrollToAnchor";


const App = () => {
    return (

            <div className={classNames("app", {}, [])}>
                <ScrollToAnchor />
                <Header/>
                <Routes>
                    <Route path={'/'} element={
                        <div className={"page-wrapper"}>
                            <MainPage/>
                            <AboutPage/>
                            <Footer/>
                        </div>
                    }/>

                    <Route path="/privacy-policy" element={<PrivacyPage />} />
                    <Route path="/terms" element={<TermsPage />} />
                </Routes>
            </div>

    )
};

export default App;